import oppRegService from '@/services/oppreg.service.js'
import contactinfoService from '@/services/contactinfo.service.js'
import ChangeLogService from '../../../../../services/changelog.service'

export default {
  register: (context, SFDC_ID) => {
    context.commit('setRegisteringOpp', true)
    context.commit('setValidatedOpp', false)
    context.commit('clearOpportunityRecord')
    oppRegService.register(SFDC_ID, (res, err) => {
      if (err) {
        if (err.timeOutError) {
          context.commit('setSnackbar',
            {
              show: true,
              type: 'error',
              timeout: 0,
              message: err.message,
              oneButton: true,
              oneButtonLabel: 'Please click here to continue manual opportunity input.',
              onOneButtonClick: () => {
                context.commit('user/requestOppreg/setManualRegistration', sfdcId, { root: true })
                context.commit('user/requestOppreg/setCustomId', true, { root: true })
                context.commit('user/requestOppreg/setOppregStep', 'opportunity', {root: true})
                context.commit('setSnackbar', { show: false, oneButton: false, oneButtonLabel: '', onOneButtonClick: null }, { root: true })
              }
            }, { root: true }
          )
        } else if (err.recordNotFound || err.accountNotFound) {
          context.commit('setRecordNotFound', true)
          context.commit('setSnackbar',
            {
              show: true,
              type: 'error',
              timeout: 0,
              message: err.message
            },
            { root: true }
          )
        } else if (err.recordExist) {
          context.commit('setSnackbar',
            {
              show: true,
              type: 'error',
              timeout: 0,
              message: err.message,
              buttons: true,
              onClickYes: () => {
                context.commit('setSnackbar', { show: false }, { root: true })
                vm.$router.push({ path: `/request-oppreg/new-workload-to-existing-opportunity`, query: { id: SFDC_ID } })
              },
              onClickNo: () => {
                context.commit('setSnackbar', { show: false }, { root: true })
                vm.$router.push({ path: '/request-oppreg/view-all-requests', query: { id: SFDC_ID } })
              }
            }, { root: true }
          )
        }
      } else {
        context.commit('setOppRegistration', res)
      }
      context.commit('setRegisteringOpp', false)
      context.commit('setValidatedOpp', true)
      context.commit('setRecordNotFound', false)
    })
  },

  validateOppId: (context, sfdcId) => {
    context.commit('validatingOppId', true)
    context.commit('setValidatedOpp', false)
    oppRegService.register(sfdcId, (res, err) => {
      if (err) {
        if (err.timeOutError) {
          context.commit('setSnackbar',
            {
              show: true,
              type: 'error',
              timeout: 0,
              message: err.message,
              oneButton: true,
              oneButtonLabel: 'Please click here to continue manual opportunity input.',
              onOneButtonClick: () => {
                context.commit('user/requestOppreg/setManualRegistration', sfdcId, { root: true })
                context.commit('user/requestOppreg/setCustomId', true, { root: true })
                context.commit('user/requestOppreg/setOppregStep', 'opportunity', {root: true})
                context.commit('setSnackbar', { show: false, oneButton: false, oneButtonLabel: '', onOneButtonClick: null }, { root: true })
              }
            }, { root: true }
          )
        } else if (err.recordNotFound || err.accountNotFound) {
          context.commit('setRecordNotFound', true)
          context.commit('setSnackbar',
            {
              show: true,
              type: 'error',
              timeout: 0,
              message: err.message
            },
            { root: true }
          )
        } else if (err.recordExist) {
          context.commit('setSnackbar',
            {
              show: true,
              type: 'error',
              message: err.message,
              timeout: 0,
              buttons: false,
              onClickYes: () => {
                context.commit('setSnackbar', { show: false }, { root: true })
                context.dispatch('sendAwsOppregEmail', sfdcId)
                vm.$router.push({ path: `/request-oppreg/new-workload-to-existing-opportunity`, query: { id: sfdcId } })
              },
              onClickNo: () => {
                context.commit('setSnackbar', { show: false }, { root: true })
                vm.$router.push({ path: '/request-oppreg/view-all-requests', query: { id: sfdcId } })
              }
            }, { root: true }
          )
        }
        context.commit('validatingOppId', false)
      } else {
        context.commit('setOppRegistration', res)
        context.commit('setValidatedOpp', true)
        context.commit('validatingOppId', false)
        context.commit('setRecordNotFound', false)
      }
    })
  },

  validateExistingOppId: async (context, sfdcId) => {
    context.commit('validatingOppId', true)
    context.commit('setValidatedOpp', false)

    // let sfOpp = await oppRegService.findOpportunityBySfId(sfdcId)
    // if (!sfOpp.data) {
    //   context.commit('validatingOppId', false)
    //   context.commit('setSnackbar',
    //     {
    //       show: true,
    //       type: 'error',
    //       timeout: 20000,
    //       message: `Salesforce ID not valid. Please check the ID. If you’ve entered a new opportunity in Salesforce within the last 24 hours, please wait 1 day for the ID to batch to the Opportunity Registration database.`
    //     }, { root: true }
    //   )
    // } else {
      let opp = await oppRegService.findOpportunityById(sfdcId)
      if (opp) {
        context.commit('validatingOppId', false)
        context.commit('setValidatedOpp', true)
      } else {
        context.commit('validatingOppId', false)
        context.commit('setSnackbar',
          {
            show: true,
            type: 'warning',
            timeout: 10000,
            message: `This record is not yet registered. Do you want to register this opportunity ${sfdcId}?`,
            buttons: true,
            onClickYes: () => {
              vm.$router.push({ path: `/request-oppreg/external-oppreg`, query: { id: sfdcId } })
              context.commit('setSnackbar', { show: false }, { root: true })
            },
            onClickNo: () => {
              context.commit('setSnackbar', { show: false }, { root: true })
            }
          }, { root: true }
        )
      }
    // }
  },

  generateId: (context, type) => {
    context.commit('setLoader', { loading: true, text: 'Generating Id' }, { root: true })
    oppRegService.generateId(type, (res, err) => {
      if (err) {

      } else {
        let id = type === 'internal' ? res.dxcint_counter : res.dxcsub_counter
        context.commit('setSfdcId', id)
        context.commit('setCustomId', true)
        context.commit('setOpportunityId', id)
        if (type !== 'internal' && type !== 'subsidiary') {
          context.dispatch('sendAwsOppregEmail', id)
        }
      }
      context.commit('setLoader', { loading: false, text: 'Generating Id' }, { root: true })
    })
  },

  sendAwsOppregEmail: (context, id) => {
    console.log('sending Oppreg email')
    // AGAM-1276 - Disables Product Offering Verified email
    // oppRegService.sendSfdcVerificationEmail(id)
  },

  submitOppRegForm: (context, formData) => {
    context.commit('setSubmittingOppForm', true)
    context.commit('clearWorkloadForm')
    oppRegService.oppSubmit(formData, (res, err) => {
      if (err) {
        context.commit('setSnackbar',
          {
            show: true,
            type: 'error',
            timeout: 10000,
            message: 'An error has occured while saving the registration. Please contact administrator'
          },
          { root: true }
        )
      } else {
        context.commit('setSubmittingOppForm', false)
        // context.commit('setShowOppForm', false)
        context.commit('setWorkloadData', {
          SFDC_Id: formData.opportunity.Opportunity_Id,
          OppReg_Id: formData.opportunity.Opportunity_Id,
          Requestor_Id: vm.$store.state.currentUser.requestor_id
        })
        // context.commit('setShowOppWorkload', true)
        // context.commit('setOppregStep', 'workload') *
        // context.commit('clearValidationErrors', { root: true })
      }
    })
  },

  submitWorkload: async (context, workload) => {
    context.commit('setLoader', { loading: true, text: 'Please wait while the page is loading...' }, { root: true })
    // const { Workload_Description, OppReg_id, SignDate, ...workloadFields } = workload.fields

    switch (workload.fields.Workload_Status) {
      case 'Submitted by User':
        context.commit('setWorkloadLoading', { submitting: true })
        break
      case 'Incomplete':
      case 'Ready for submission':
        context.commit('setWorkloadLoading', { savingForLater: true })
        context.commit('setWorkloadLoading', { enteringNew: true })
        break
    }
    await contactinfoService.getByEmail(context.state.workloadForm.contact.Contact_Email, (contact, err) => {
      if (err) {
        console.log('contact created')
      } else {
        workload.fields.Contact_Id = contact.Id
        contactinfoService.update({ ...context.state.workloadForm.contact, Id: contact.Id })
      }
    })
    // if we still don't have a contact id, create new
    if (!workload.fields.Contact_Id) {
      await contactinfoService.create(context.state.workloadForm.contact, (id, err) => {
        if (err) {
        } else {
          workload.fields.Contact_Id = id
        }
      })
    }
    let dialogAtts = {}
    
    switch (workload.fields.Workload_Status) {
      case 'Submitted by User':
        // set OppReg_Req_Date to be today's date
        workload.fields.OppReg_Req_Date = window.moment().format('YYYY-MM-DD')
        context.commit('setWorkloadLoading', { submitting: true })
        // AGAM-1276 - Disables Product Offering Verified email
        // if(workload.validatedSfdcId !== '' && workload.oppType ===''){
        //   oppRegService.sendSfdcVerificationEmail(workload.validatedSfdcId)
        // }
        if(workload.oppType !==''){
          await oppRegService.generateId(workload.oppType, (res, err) => {
            if (err) {
            } else {      
              let id 
              if(workload.oppType === 'internal') {
                id = res.dxcint_counter 
              } else if (workload.oppType ==='subsidiary') {
                id = res.dxcsub_counter 
              } else if (workload.oppType === 'gainwell') {
                id = res.dxcgnw 
              }
              context.commit('setSfdcId', id)
              context.commit('setCustomId', true)
              context.commit('setOpportunityId', id)
              if (workload.oppType !== 'internal' && workload.oppType !== 'subsidiary' && workload.oppType !== 'gainwell') {
                context.dispatch('sendAwsOppregEmail', id)
              }
            }
          })
        }
        oppRegService.oppSubmit(workload, (res, err) => {
          if (err) {
            context.commit('setSnackbar',
              {
                show: true,
                type: 'error',
                timeout: 10000,
                message: 'An error has occured while saving the registration. Please contact administrator'
              },
              { root: true }
            )
          } else {
            
            context.commit('setWorkloadData', {
              SFDC_Id: workload.oppFields.opportunity.Opportunity_Id,
              OppReg_Id: workload.oppFields.opportunity.Opportunity_Id,
              Requestor_Id: vm.$store.state.currentUser.requestor_id
            })
              oppRegService.workLoadSubmit(vm.$store.state['user/requestOppreg'].workloadForm.fields, (id, err) => {
                if (err) {
                  context.commit('setSnackbar',
                    {
                      show: true,
                      type: 'error',
                      timeout: 10000,
                      message: 'An error has occured while saving the registration. Please contact administrator'
                    },
                    { root: true }
                  )
                } else {

                  let logChangeTo = {}
                  let workloadLogData = workload.fields
                  // only include fields that are not empty
                  for (const property in workloadLogData) {
                    if (workloadLogData[property]) {
                      logChangeTo[property] = workloadLogData[property]
                    }
                  }

                  context.commit('setChangeLogRecord', { id: id, changeTo: logChangeTo, module:'oppreg'}, { root: true })
                  ChangeLogService.create(context.rootState.logRecord)
                  context.commit('setWorkloadLoading', { submitting: false })
                  context.commit('insertWorkloadListRecord', workload.fields)
                  
                  // get all related workloads with status of 'ready'
                  let readyWorkloads = context.state.workloadList.filter(item => item.Workload_Status === 'Ready for submission' && item.OppReg_Id === vm.$store.state['user/requestOppreg'].workloadForm.fields.SFDC_Id)
                  // add the recently submitted workload
                  readyWorkloads.push(vm.$store.state['user/requestOppreg'].workloadForm.fields)
                  oppRegService.submitAllWorkload(vm.$store.state['user/requestOppreg'].workloadForm.fields.SFDC_Id, readyWorkloads, (res, err) => {
                    if (err) {
                      context.commit('setSnackbar', {
                        show: true, type: 'error',
                        timeout: 30000, message: err.message
                        }, { root: true }
                      )
                    } else {
                      context.commit('setLoader', { loading: false, text: 'Please wait while the page is loading...' }, { root: true })
                      vm.$router.push({ path: `/request-oppreg/workload-submission-confirmation`, query: { id: vm.$store.state['user/requestOppreg'].workloadForm.fields.SFDC_Id } })
                      context.commit('clearWorkloadForm')
                      context.commit('resetDialog', null, { root: true })
                      context.commit('app/setSelectedFilter', 99, { root: true })
                      }
                  })
                }
              })
          }
        })
        break
      case 'Incomplete':
      case 'Ready for submission':
        context.commit('setWorkloadLoading', { savingForLater: true })
        context.commit('setWorkloadLoading', { enteringNew: true })
        dialogAtts = {
          show: true,
          type: 'link',
          title: 'Your workload ' + workload.fields.Registration_Id + ' has been saved and can be found by clicking the View All Requests button.',
          noHandler: () => {
            context.commit('showDialog', { ...dialogAtts, show: false }, { root: true })
          },
          noLabel: 'Ok',
          linkHandler: () => {
            context.commit('showDialog', { ...dialogAtts, show: false }, { root: true })
            vm.$router.push({ path: `/request-oppreg/view-all-requests` })
          },
          linkLabel: 'view all requests',
          persistent: false
        }

        oppRegService.workLoadSubmit(workload.fields, (id, err) => {
          context.commit('setWorkloadLoading', { savingForLater: false, enteringNew: false })
          if (err) {
            // throw error
            context.commit('setSnackbar',
              {
                show: true,
                type: 'error',
                timeout: 10000,
                message: 'An error has occured while saving the registration. Please contact administrator'
              },
              { root: true }
            )
          } else {
            context.commit('setChangeLogRecord', { id: id, changeTo: workload.fields, module: 'oppreg' }, { root: true })
            ChangeLogService.create(context.rootState.logRecord)
            context.commit('showDialog', { ...dialogAtts, show: true }, { root: true })
            context.commit('insertWorkloadListRecord', { ...workload.fields, Project_Id: id, Contact_Email: context.state.workloadForm.contact.Contact_Email })
            context.commit('clearWorkloadForm')
            context.commit('showNewWorkload', workload.fields.SFDC_Id)
            context.commit('setWorkloadStep', 1)
            context.commit('toggleManualRegOption', false)
            context.commit('removeManualRegistration')
          }
        })
        break
      default:
        break
    }
  },

  submitMultipleWorkload: (context, workloads) => {
    // build dialog desc
    let dialogDesc = workloads.reduce((desc, workload) => desc + `<li>${workload.Workload_Title}</li>`, '')
    let workloadIds = workloads.map((workload) => workload.Project_Id)
    let strWorkloadIds = '(' + workloadIds.join(',') + ')'
    let dialogAtts = {
      type: 'confirmation',
      persistent: true,
      title: 'Submit the following workloads?',
      description: `<ul>${dialogDesc}</ul>`,
      yesLabel: 'Yes, submit',
      noLabel: 'No'
    }
    context.commit('showDialog',
      {
        ...dialogAtts,
        show: true,
        yesHandler: () => {
          context.commit('showDialog', { ...dialogAtts, show: true, yesHandlerLoading: true }, { root: true })
          oppRegService.submitMultipleWorkload(strWorkloadIds, workloads, (res, err) => {
            if (err) {
              // handle error here
            } else {
              context.commit('updateSubmittedWorkloadList', workloadIds)
              context.commit('setSnackbar',
                {
                  show: true,
                  type: 'success',
                  timeout: 3000,
                  message: `Your workloads have been successfully submitted`
                },
                { root: true }
              )
              context.commit('resetDialog', null, { root: true })
            }
          })
        },
        noHandler: () => {
          context.commit('resetDialog', null, { root: true })
        }
      },
      { root: true }
    )
  },

  updateWorkload: async (context, discountInfo) => {
    if (workload.fields.Workload_Status === 'Ready for submission') {
      context.commit('setWorkloadLoading', { savingForLater: true })
    } else {
      context.commit('setWorkloadLoading', { submitting: true })
    }

    await contactinfoService.getByEmail(workload.contact.Contact_Email, (contact, err) => {
      if (err) {
        console.log('contact created')
      } else {
        workload.fields.Contact_Id = contact.Id
        contactinfoService.update({ Id: contact.Id, ...workload.contact })
      }
    })
    // if we still don't have a contact id, create new
    if (!workload.fields.Contact_Id) {
      await contactinfoService.create(workload.contact, (id, err) => {
        if (err) {
        } else {
          workload.fields.Contact_Id = id
        }
      })
    }
    workload.fields.Date_Updated = window.moment().format('YYYY-MM-DD hh:mm:ss')
    oppRegService.updateWorkload(workload.fields, (res, err) => {
      if (err) {

      } else {
        context.commit('clearLogRecord', null, { root: true })
        context.commit('setChangeLogRecord', { changeTo: workload.fields, module: 'oppreg' }, { root: true })
        ChangeLogService.create(context.rootState.logRecord)
        // context.commit('setChangeLogRecord', { changeFrom: workload.fields }, { root: true })
        context.commit('setWorkloadLoading', { submitting: false })
        context.commit('setWorkloadLoading', { savingForLater: false })
        context.commit('setWorkloadContact', { ...context.state.workloadForm.contact, Id: workload.fields.Contact_Id })
        context.commit('updateWorkloadListRecord', { ...workload.fields, Contact_Email: context.state.workloadForm.contact.Contact_Email })
        if (workload.fields.Workload_Status === 'Ready for submission') {
          context.commit('setSnackbar',
            {
              show: true,
              buttons: false,
              type: 'success',
              timeout: 3000,
              message: `Your workload has been successfully updated`
            },
            { root: true }
          )
        } else {
          // context.commit('clearWorkloadForm')
          context.commit('resetDialog', null, { root: true })
          context.commit('app/setSelectedFilter', 99, { root: true })
          vm.$router.push({ path: `/request-oppreg/workload-submission-confirmation`, query: { id: workload.fields.SFDC_Id } })
        }
      }
    })
  },

  submitDiscount: async (context, discountInfo) => {
    let discountDetails = {
      Registration_Id: context.state.updateDiscount.registrationId,
      ...discountInfo
    }
    context.commit('updatingDiscount', true)
    oppRegService.submitDiscount(discountDetails, (res, err) => {
      if (err) {
      } else {

        context.commit('setChangeLogRecord', {
            changeTo: {...discountInfo}
        },{ root: true })
        ChangeLogService.create(context.rootState.logRecord, (res, err) => {
          console.log('clearing log record')
          context.commit('clearLogRecord', null, { root: true })
        })

        context.commit('updateWorkloadListRecord', { ...context.state.workloadForm.fields, ...discountInfo })
        context.commit('updatingDiscount', false)

        context.commit('showUpdateDiscountSuccess', true)

        // context.commit('setSnackbar',
        //   {
        //     show: true,
        //     type: 'success',
        //     timeout: 15000,
        //     message: 'You have successfully updated the discount qualification',
        //     bottom: true,
        //     top: false
        //   }, { root: true }
        // )

        context.commit('resetUpdateDiscountPage')
      }
    })
  },

  getWorkloadsByOppId: (context, opportunityId) => {
    context.commit('resetNewOppRegistration')
    context.commit('showWorkloadSearching', { searching: true })
    oppRegService.getWorkloadsByOppId(opportunityId, (res, err) => {
      if (err) {
        switch (err.opportunityFound) {
          case true:
            // prompt confirm snackbar
            context.commit('setSnackbar',
              {
                show: true,
                type: 'warning',
                timeout: 10000,
                message: `This record is not yet registered. Do you want to register this opportunity ${opportunityId}?`,
                buttons: true,
                onClickYes: () => {
                  vm.$router.push({ path: `/request-oppreg/external-oppreg`, query: { id: opportunityId } })
                  context.commit('setSnackbar', { show: false }, { root: true })
                },
                onClickNo: () => {
                  context.commit('setSnackbar', { show: false }, { root: true })
                }
              }, { root: true }
            )
            break
          case false:
            context.commit('setWorkloadDataList', [])
            break
          default:
            break
        }
      } else {
        if (res.noWorkloadsFound) {
          // context.commit('setSnackbar',
          //   {
          //     show: true,
          //     type: 'info',
          //     timeout: 20000,
          //     message: res.message,
          //     buttons: false
          //   },
          //   { root: true }
          // )

        } else {
          // set workload list
          context.commit('setWorkloadDataList', res.workloads)
        }
        // context.commit('setOpportunityFound', res.id)
      }
      context.commit('showWorkloadSearching', { searching: false })
    })
  },

  getOppRegRequestData: (context, params) => {
    context.commit('resetNewOppRegistration')
    context.commit('showWorkloadSearching', { searching: true })
    context.commit('setLoadingWorkloadData', true)
    context.commit('clearWorkload', [])
    oppRegService.getOppRegRequests(params, (res, err) => {
      if (err) {
        if (err.noRecordFound) {
          context.commit('setSnackbar',
            {
              show: true,
              type: 'error',
              timeout: 20000,
              message: err.message
            },
            { root: true }
          )
          context.commit('setNotification', { withError: true })
          context.commit('setWorkloadDataList', [])
          context.commit('setNextWorkloadData', '')
          context.commit('setLoadingWorkloadData', false)
        }
      } else {
        if (res.noWorkloadsFound) {
          context.commit('setNotification', { withError: true })
          context.commit('setSnackbar',
            {
              show: true,
              type: 'info',
              timeout: 20000,
              message: res.message,
              buttons: false
            },
            { root: true }
          )
        } else {
          if (res.OppRegRequestsData.data_result && res.OppRegRequestsData.data_result.length > 0) {
            // context.commit('setWorkloadDataList', res.OppRegRequestsData.data_result)
            context.commit('setListWorkload', res.OppRegRequestsData.data_result)
            context.commit('setNextWorkloadData', res.OppRegRequestsData.next_key)
            context.commit('setLoadingWorkloadData', false)
          } else {
            context.commit('setWorkloadDataList', [])
            context.commit('setNextWorkloadData', '')
            context.commit('setNotification', { withError: true })
            context.commit('setLoadingWorkloadData', false)
          }
        }
      }
      context.commit('showWorkloadSearching', { searching: false })
    })
  },

  getOppRegDiscountData: (context, opportunityId) => {
    context.commit('setDiscountPageListData', [])
    context.commit('searchingDiscountRecord', true)
    oppRegService.retrieveOppregRequestWithNoDiscounts({sfdcId: opportunityId}, (res, err) => {
      if (err) {
        // handle error
        if (err.noRecordFound) {
          context.commit('setSnackbar',
            {
              show: true,
              type: 'error',
              timeout: 20000,
              message: err.message
            },
            { root: true }
          )
          context.commit('setWorkloadDataList', [])
        }

        if (err.acctExist) {
          context.commit('setSnackbar',
            {
              show: true,
              type: 'error',
              timeout: 20000,
              message: err.message
            },
            { root: true }
          )
          context.commit('setAccountRecordFound', true)
          context.commit('setDiscountPageListData', [])
        }
      } else {
        
        if (res.OppRegRequestsData && res.OppRegRequestsData.length > 0) {
          context.commit('setDiscountPageListData', res.OppRegRequestsData)
        } else {
          context.commit('setDiscountPageListData', [])
        }
      }
      context.commit('searchingDiscountRecord', false)
    })
  },

  validateRegistrationId: (context, registrationId) => {
    context.commit('setRegistrationIdValidation', { loading: true, errorMessage: '', successMessage: '', validated: false })
    console.log('validating')
    console.log(registrationId)
    oppRegService.validateRegistrationId(registrationId, (res, err) => {
      if (err && err.duplicateTitle) {
        context.commit('setRegistrationIdValidation', {
          loading: false,
          error: true,
          success: false,
          errorMessage: 'This title has already been used. Please enter a unique title'
        })
      } else {
        context.commit('setRegistrationIdValidation', {
          loading: false,
          success: true,
          error: false,
          successMessage: 'This title is available to use',
          validated: true
        })

        context.commit('setRegistrationID', registrationId)
      }
    })
  },

  loadRelatedContact: (context, id) => {
    context.commit('setLoadingContact', true)
    contactinfoService.getById(id, (res, err) => {
      if (err) {

      } else {
        context.commit('setWorkloadContact', res)
      }
      context.commit('setLoadingContact', false)
    })
  }
}
